import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12.9844" r="9.25" stroke="var(--svg-color-main, black)" strokeWidth="1.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 8.98242C13 9.53471 12.5523 9.98242 12 9.98242C11.4477 9.98242 11 9.53471 11 8.98242C11 8.43014 11.4477 7.98242 12 7.98242C12.5523 7.98242 13 8.43014 13 8.98242ZM13.75 15.9814C13.3358 15.9814 13 15.6457 13 15.2314V11.2314C13 10.8172 12.6642 10.4814 12.25 10.4814H10V11.4814H10.25C10.6642 11.4814 11 11.8172 11 12.2314V15.2314C11 15.6457 10.6642 15.9814 10.25 15.9814H10V16.9814H14V15.9814H13.75Z"
        fill="var(--svg-color-main, black)"
      />
    </svg>
  )
}
